import React from 'react';
import { Box, Link, Stack, Switch, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { adminColors, adminTypography } from '../../../../styles/adminDesignTokens';
import {
  adminIconTitleSx,
  adminTextLinkSx,
} from '../../../../styles/adminComponentStyles';

type AgentConfigurationHeaderProps = {
  isAgentLoading: boolean;
  hasAgentDeviceId: boolean;
  agentDeviceId: string | null;
  changingDevice: boolean;
  onChangeDevice: () => void;
  posEnabled: boolean;
  onPosEnabledChange: (checked: boolean) => void;
  checkboxIcon: React.ReactNode;
  checkboxCheckedIcon: React.ReactNode;
  showSyncGamesToPos: boolean;
  syncGamesToPosEnabled: boolean;
  syncGamesToPosUpdating: boolean;
  onSyncGamesToPosChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const AgentConfigurationHeader: React.FC<AgentConfigurationHeaderProps> = ({
  isAgentLoading,
  hasAgentDeviceId,
  agentDeviceId,
  changingDevice,
  onChangeDevice,
  posEnabled,
  onPosEnabledChange,
  checkboxIcon,
  checkboxCheckedIcon,
  showSyncGamesToPos,
  syncGamesToPosEnabled,
  syncGamesToPosUpdating,
  onSyncGamesToPosChange,
}) => {
  return (
    <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 0 }}>
      <Box sx={adminIconTitleSx}>
        <Box className="AdminIconTitle-icon">
          <img src="/Icons/AgentConfiguration.svg" width={22} height={22} alt="Agent configuration" />
        </Box>
      </Box>
      <Box sx={{ alignItems: 'start', display: 'flex', flex: 1, gap: 1, justifyContent: 'space-between', minWidth: 0 }}>
        <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', gap: '2px', minWidth: 0 }}>
          <Typography sx={{ ...adminTypography.cardTitle, color: adminColors.primary }}>
            POS Setup
          </Typography>
          {!isAgentLoading && hasAgentDeviceId ? (
            <Box sx={{ alignItems: 'center', display: 'flex', gap: 1, justifyContent: 'flex-start' }}>
              <Typography sx={{ ...adminTypography.helper, color: '#222b4599', overflowWrap: 'anywhere' }}>
                Device ID: <span style={{ fontWeight: 600, color: '#222B45' }}>{agentDeviceId || '—'}</span>
              </Typography>
              <Link
                component="button"
                onClick={onChangeDevice}
                sx={{
                  ...adminTextLinkSx,
                  alignItems: 'center',
                  display: 'inline-flex',
                  gap: '4px',
                  opacity: changingDevice ? 0.6 : 1,
                  pointerEvents: changingDevice ? 'none' : 'auto',
                }}
              >
                {changingDevice ? 'Changing...' : 'Change'}
              </Link>
            </Box>
          ) : null}
        </Box>
        {showSyncGamesToPos ? (
          <Stack direction="row" spacing={1} alignItems="center" sx={{ flexShrink: 0, minWidth: 0 }}>
            <Typography
              sx={{ ...adminTypography.helper, color: adminColors.text, fontWeight: 600, textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              Add New Games to POS
            </Typography>
            <Switch
              checked={syncGamesToPosEnabled}
              onChange={onSyncGamesToPosChange}
              size="small"
              disabled={syncGamesToPosUpdating}
              inputProps={{ 'aria-label': 'Add new games to My Pricebook' }}
            />
          </Stack>
        ) : null}
      </Box>
    </Stack>
  );
};

export default React.memo(AgentConfigurationHeader);
